import React, { useEffect } from "react";
import "./Login.css";
import LoginBox from "./LoginBox/LoginBox";
import Footer from "./Footer/Footer";
import Wave from "./wave.png";

function clearLocalStorage() {
  const keepValues = { "visit:page": null, authToken: null };
  Object.keys(keepValues).forEach((keyName) => {
    keepValues[keyName] = window.localStorage.getItem(keyName);
  });
  window.localStorage.clear();
  Object.keys(keepValues).forEach((keyName) => {
    if (keepValues[keyName])
      window.localStorage.setItem(keyName, keepValues[keyName]);
  });
}

function Login() {
  useEffect(() => {
    clearLocalStorage();
  }, []);

  return (
    <div className="Login">
      <div className="bg-1"></div>
      <img src={Wave} className="wave" alt="" />
      <LoginBox />
    </div>
  );
}

export default Login;
